{
	"name": "PeerJS Server",
	"description": "A server side element to broker connections between PeerJS clients.",
	"website": "https://peerjs.com/"
}
